import * as queryString from 'query-string';

export const getQueryString = () => queryString.parse(window.location.search, { ignoreQueryPrefix: true });

const SUPPORTED_LOCALE = ['en_GB', 'fi_FI', 'fr_FR', 'sv_SE', 'de_DE', 'nl_NL', 'nl_BE'];

export const getLocale =
  () => SUPPORTED_LOCALE.includes(getQueryString().locale) ? getQueryString().locale : 'en_GB';
